

<template>
  <div class="openCartDetails" id="pda-cart-summary">
    <div id="cart-desktop-header">
      <div class="total-cost-and-input">
        <h6 id="total-order-cost">
          {{ labels.cart.total[language] }}:
          <span
            v-if="discount==null || discount==0"
          >{{ isMembershipPdaOrder ? membershipCost.toFixed(2) : totalCost.toFixed(2) }}€</span>
          <span v-else>
            <span
              class="cost-before-discount"
            >{{ isMembershipPdaOrder ? membershipCost.toFixed(2) : totalCost.toFixed(2) }}</span>
            {{totalCostAfterDiscount.toFixed(2)}}€
          </span>
        </h6>
        <div class="amount-received-container">
          <input
            type="number"
            v-model="payableAmount"
            class="amount-received-input"
            placeholder="Ποσό πχ 50€"
          />
          <font-awesome-icon icon="times" @click="clearPayable()" class="clear-amount-input" />
        </div>
      </div>
      <h6 v-if="payableAmount>0" id="return-change-amount">Ρέστα: {{changeAmount.toFixed(2)}}€</h6>
    </div>

    <CartItem
      :item="item"
      :index="index"
      v-for="(item, index) in cartItems"
      :key="item.id"
      :cartSummaryInPdaDesktop="true"
      :showCost="true"
      :isMembershipPdaOrder="isMembershipPdaOrder"
      deleteIcon="trash"
    ></CartItem>
    <div
      id="send-order"
      style="margin-top: auto;"
      :class="{ 'pt-4': selectedTable && selectedTable.tableHiddenFromCartScreen }"
    >
      <TableName
        v-if="table.type!='DELIVERY' && (selectedTable==null || selectedTable==undefined || !selectedTable.tableHiddenFromCartScreen)"
        ref="tableNameComponent"
        :class="{ highlight: failedToChooseTable }"
        @table-select="onTableSelect"
        :table="table"
        :cartSummaryInPdaDesktop="true"
      ></TableName>
      <ReceiptOrNot
        ref="receiptOrNotComponent"
        @change-publish-receipt-selection="onPublishReceiptChange"
        :cartSummaryInPdaDesktop="true"
        :hideReceiptOptions="hideReceiptOptions"
        :restaurantId="service.id"
        :hotelizerIntegrationEnabled="service.hotelizerIntegrationEnabled"
        :hotelizerReceipt="service.hotelizerReceipt"
        :selectedTable="selectedTable"
        v-if="selectedTable && (selectedTable.wayOfReceiptPublishForPda=='MANUAL' || selectedTable.wayOfReceiptPublishForPda=='AUTOMATIC') && service.publishesReceipts && isAbleToPublishReceipts && !publishesAlwaysReceipt"
      ></ReceiptOrNot>
      <div
        v-if="(isPaymentsOptionEnabled || (selectedTable && selectedTable.showPdaPaymentsOption)) && table.type!='DELIVERY' && paymentType=='CARD_TERMINAL' && cardTerminals.length>0 && service.publishesReceipts && selectedTable && selectedTable.typeOfReceipt=='FINAL_RECEIPT' && selectedTable.cardTerminalEnabledForPdaOrders"
        id="card-selection-container"
        :class="{ highlight: failedToChooseCardTerminal }"
      >
        <div id="card-terminal-label-and-name">
          <div v-if="cardTerminals.length>1" id="card-terminal-label">
            <h6 id="card-terminal-selection-title">Τερματικό:</h6>
            <select
              id="card-terminal-select-dropdown"
              @change="onCardTerminalSelect()"
              required
              v-model="selectedCardTerminal"
            >
              <option selected disabled :value="null">Επιλέξτε</option>
              <option
                v-for="cardTerminal in cardTerminals"
                :key="cardTerminal.id"
                :value="cardTerminal.id"
              >{{ cardTerminal.friendlyName }}</option>
            </select>
          </div>

          <div class="iris-option" :class="{ 'mt-0': cardTerminals.length==1 }">
            <label class="switch" style="margin-left: 0px; margin-top: 0px;">
              <input type="checkbox" v-model="irisPayment" />
              <span class="slider round"></span>
            </label>
            <img
              v-if="irisPayment"
              class="iris-logo"
              @click="toggleIrisPayment()"
              src="../assets/images/logo-iris.png"
              alt
            />
            <img
              v-else
              class="iris-logo"
              @click="toggleIrisPayment()"
              src="../assets/images/logo-iris-bw.png"
              alt
            />
          </div>
        </div>
      </div>
      <!-- <MembershipOrNot
        @change-membership-order-or-not="onMembershipOrderChange"
        v-if="service.membershipEnabled"
      ></MembershipOrNot>-->
      <!-- <ChooseTreatOrNot
        ref="chooseTreatComponent"
        v-if="isAbleToTreat && table.type!='DELIVERY'"
        @change-treat-or-not="onTreatChange"
        :cartSummaryInPdaDesktop="true"
      ></ChooseTreatOrNot>-->
      <div v-if="isAbleToDiscount && table.type!='DELIVERY'" id="discount-outer-container">
        <h6 v-if="typeOfDiscount=='FINAL_PRICE'" id="discount-final-price-header">Έκπτωση</h6>
        <div
          v-if="typeOfDiscount=='FINAL_PRICE'"
          id="discount-input-container"
          class="zero-margin-top"
        >
          <h6 id="discount-header">Τελική τιμή:</h6>
          <input
            id="discount-input"
            @input="adjustDiscount()"
            v-model="finalPriceAfterDiscount"
            type="number"
            placeholder="πχ 3€"
          />
        </div>

        <div v-if="typeOfDiscount=='PERCENTAGE'" id="discount-input-container" class="margin-top-4">
          <h6 id="discount-header">Έκπτωση:</h6>
          <input
            id="discount-input"
            @input="adjustFinalPriceAfterDiscount()"
            v-model="discount"
            type="number"
            placeholder="πχ 10%"
          />
        </div>
        <div id="discount-options" class="prevent-select">
          <div
            class="discount-option"
            @click="selectDiscountType('PERCENTAGE')"
            style="margin-right: 20px;"
          >
            <input
              class="discount-type-input"
              type="radio"
              value="PERCENTAGE"
              v-model="typeOfDiscount"
            />
            <h6 class="discount-option-title">Ποσοστό</h6>
          </div>
          <div class="discount-option" @click="selectDiscountType('FINAL_PRICE')">
            <input
              class="discount-type-input"
              type="radio"
              value="FINAL_PRICE"
              v-model="typeOfDiscount"
            />
            <h6 class="discount-option-title">Τελική τιμή</h6>
          </div>
        </div>
      </div>

      <div
        v-if="(isPaymentsOptionEnabled || (selectedTable && selectedTable.showPdaPaymentsOption)) && table.type!='DELIVERY' && !orderOnHold && userHasRightsForPaymentMethod"
        id="choose-payment-container"
      >
        <div
          v-if="table.type=='HOTEL_ROOM'"
          class="payment-option"
          @click="selectPaymentType('ROOM_CHARGE')"
          :class="{ 'selected-payment-type': paymentType=='ROOM_CHARGE' }"
          style="margin-right:8px"
        >
          Χρέωση Δωμ.
          <font-awesome-icon v-if="paymentType=='ROOM_CHARGE'" style="margin-left:5px" icon="check"></font-awesome-icon>
        </div>
        <div
          v-if="!tableIdsToHideCashAndCardPayment.includes(table.id)"
          class="payment-option"
          @click="selectPaymentType('CASH')"
          style="margin-right:4px"
          :class="{ 'selected-payment-type': paymentType=='CASH' }"
        >
          Μετρητά
          <font-awesome-icon v-if="paymentType=='CASH'" style="margin-left:5px" icon="check"></font-awesome-icon>
        </div>
        <div
          v-if="!tableIdsToHideCashAndCardPayment.includes(table.id)"
          class="payment-option"
          @click="selectPaymentType('CARD_TERMINAL')"
          style="margin-left:4px"
          :class="{ 'selected-payment-type': paymentType=='CARD_TERMINAL' }"
        >
          Κάρτα
          <font-awesome-icon
            v-if="paymentType=='CARD_TERMINAL'"
            style="margin-left:5px"
            icon="check"
          ></font-awesome-icon>
        </div>
        <div
          v-if="selectedTable && selectedTable.supportsBankPayment"
          class="payment-option"
          @click="selectPaymentType('BANK_ACCOUNT')"
          :class="{ 'selected-payment-type': paymentType=='BANK_ACCOUNT' }"
          style="margin-left:8px"
        >
          Τράπεζα
          <font-awesome-icon
            v-if="paymentType=='BANK_ACCOUNT'"
            style="margin-left:5px"
            icon="check"
          ></font-awesome-icon>
        </div>
        <div
          v-if="selectedTable && selectedTable.supportsOnCreditPayment"
          class="payment-option"
          @click="selectPaymentType('ON_CREDIT')"
          :class="{ 'selected-payment-type': paymentType=='ON_CREDIT', 'ml-8': !tableIdsToHideCashAndCardPayment.includes(table.id)}"
        >
          Πίστωση
          <font-awesome-icon v-if="paymentType=='ON_CREDIT'" style="margin-left:5px" icon="check"></font-awesome-icon>
        </div>
      </div>

      <textarea
        v-if="table.type!='DELIVERY' && !orderOnHold && (selectedTable==null || selectedTable==undefined || !selectedTable.totalCommentHidden)"
        :disabled="sendingOrder"
        v-model="orderComment"
        placeholder="Προαιρετικά σχόλια παραγγελίας"
        id="comment-text-area"
      />
      <div v-if="orderOnHold" id="order-on-hold-container">
        <p id="order-on-hold-message">
          <clip-loader style="margin-top: 2px; margin-right: 4px" size="16px" color="#003340" />
          <span>Αναμονή πληρωμής σε POS</span>
        </p>
        <img
          id="waiting-gif"
          src="https://fluter.fra1.cdn.digitaloceanspaces.com/assets/client/pay-at-terminal-bg-gray.gif"
          alt
        />
      </div>

      <p v-if="errorDuringOrder" id="error-message">{{errorMessage}}</p>
      <p v-if="!isServiceOpen" id="unavailable-store-msg">Παραγγελίες μη διαθέσιμες</p>
      <p
        v-if="!isServiceOpen"
        id="store-schedule"
      >Ωράριο: {{service.startTime.slice(0, -3)}} - {{service.endTime.slice(0, -3)}}</p>
      <clip-loader
        v-if="sendingOrder && !orderOnHold"
        :loading="sendingOrder"
        style="margin-bottom: 8px; margin-top: 8px"
        size="30px"
        color="#003340"
      />
      <Button
        v-if="!sendingOrder && isServiceOpen"
        @click="completeOrder()"
        :class="{ grayOut: cartItems.length == 0, 'mt-18': selectedTable && selectedTable.totalCommentHidden }"
        id="send-order-button"
      >{{ labels.cart.completeOrder[language] }}</Button>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";

import UserApi from "../api/user";
import OrderApi from "../api/order"
import StoreApi from "../api/stores"

import CartItem from "./CartItem";
import ReceiptOrNot from "./ReceiptOrNot";
import TableName from "./TableName";
import ChooseTreatOrNot from "./ChooseTreatOrNot";
import Button from "./Button";
export default {
  name: "CartSummaryPdaDesktop",
  components: { CartItem, ReceiptOrNot, TableName, ChooseTreatOrNot, ClipLoader, Button },
  props: ["cartItems", "table", "service", "storeId", "redirectBackTo", "hideBackToServicesButton", "isServiceOpen"],
  data() {
    return {
      failedToChooseTable: false,
      failedToChooseCardTerminal: false,
      isPaymentsOptionEnabled: false,
      paymentType: 'CASH',
      orderComment: "",
      willTreatProducts: false,
      isMembershipPdaOrder: false,
      sendingOrder: false,
      errorDuringOrder: false,
      errorMessage: "",
      payableAmount: null,
      willPublishReceiptSelection: false,
      selectedCardTerminal: null,
      hideReceiptOptions: false,
      discount: null,
      typeOfDiscount: "FINAL_PRICE",
      finalPriceAfterDiscount: null,
      irisPayment: false,
      orderOnHold: false,
      tableIdsToHideCashAndCardPayment: ['12534', 12534, '12351', 12351, '13502', 13502, '13504', 13504, '13507', 13507, '13594', 13594, '14606', 14606,], //TODO fix this properly from server and consume the selected table not the route table
    };
  },
  watch: {
    isLoggedIn(loggedIn) {
      if (loggedIn) {
        this.errorDuringOrder = false;
        this.errorMessage = "";
      } else {
      }
    }
  },
  computed: {
    language() {
      return this.$store.getters.getLanguage;
    },
    adminAccounts() {
      return this.$store.getters.getAdminAccounts;
    },

    cardTerminals() {
      let adminAcountOfUserForCurrentRestaurant = this.adminAccounts.find(adminAccount => adminAccount.restaurantId == this.service.id);
      if (adminAcountOfUserForCurrentRestaurant != null && adminAcountOfUserForCurrentRestaurant != undefined && adminAcountOfUserForCurrentRestaurant.cardTerminalsOfUser != null && adminAcountOfUserForCurrentRestaurant.cardTerminalsOfUser.trim().length > 0) {
        let cardTerminalsOfUser = adminAcountOfUserForCurrentRestaurant.cardTerminalsOfUser.split(",");
        let cardTerminalsToShow = this.$store.getters.getCardTerminals.filter(cardTerminal => cardTerminal.restaurantId == this.service.id && cardTerminalsOfUser.includes(`${cardTerminal.id}`));
        if (cardTerminalsToShow.length == 0) {
          return this.$store.getters.getCardTerminals.filter(cardTerminal => cardTerminal.restaurantId == this.service.id);
        }
        return cardTerminalsToShow;
      } else {
        return this.$store.getters.getCardTerminals.filter(cardTerminal => cardTerminal.restaurantId == this.service.id);
      }
    },

    isAbleToTreat() {
      let adminAccountOfRestaurant = this.adminAccounts.find(account => account.restaurantId == this.service.id);
      if (adminAccountOfRestaurant == undefined || adminAccountOfRestaurant == null) {
        return false;
      } else {
        return adminAccountOfRestaurant.ableToTreat;
      }
    },

    isAbleToDiscount() {
      let adminAccountOfRestaurant = this.adminAccounts.find(account => account.restaurantId == this.service.id);
      if (adminAccountOfRestaurant == undefined || adminAccountOfRestaurant == null) {
        return false;
      } else {
        return adminAccountOfRestaurant.ableToDiscount;
      }
    },

    isAbleToPublishReceipts() {
      let adminAccountOfRestaurant = this.adminAccounts.find(account => account.restaurantId == this.service.id);
      if (adminAccountOfRestaurant == undefined || adminAccountOfRestaurant == null) {
        return false;
      } else {
        return adminAccountOfRestaurant.ableToPublishReceipts;
      }
    },

    publishesAlwaysReceipt() {
      let adminAccountOfRestaurant = this.adminAccounts.find(account => account.restaurantId == this.service.id);
      if (adminAccountOfRestaurant == undefined || adminAccountOfRestaurant == null) {
        return false;
      } else {
        return adminAccountOfRestaurant.publishesAlwaysReceipt;
      }
    },

    userHasRightsForPaymentMethod() {
      let userCanSelectPaymentMethod = true;
      let adminAccountOfRestaurant = this.adminAccounts.find(account => account.restaurantId == this.service.id);
      if (adminAccountOfRestaurant != null && (!adminAccountOfRestaurant.ableForPartialCashPayment || !adminAccountOfRestaurant.ableForPartialCardPayment)) {
        userCanSelectPaymentMethod = false;
      }
      return userCanSelectPaymentMethod;
    },

    selectedTable() {
      return this.$store.getters.getSelectedTable;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    numberOfServices() {
      return this.$store.getters.getNumberOfServices;
    },
    authToken() {
      return this.$store.getters.getUserAuthToken;
    },
    jwt() {
      return this.$store.getters.getUserJWT;
    },
    isUserVerified() {
      return this.$store.getters.isUserVerified;
    },
    totalCost() {
      return this.$store.getters.getTotalCost;
    },
    membershipCost() {
      if (this.service.membershipEnabled) {
        return this.$store.getters.getTotalMembershipCost;
      } else {
        return this.totalCost;
      }
    },

    totalCostAfterDiscount() {
      if (this.isMembershipPdaOrder) {
        if (this.discount == null) {
          return this.membershipCost;
        }
        if (this.discount > 0 && this.discount <= 100) {
          let costAfterDiscount = this.membershipCost * (1 - (this.discount / 100));
          return costAfterDiscount;
        }
        if (this.discount > 100) {
          return 0;
        }
        return this.membershipCost;
      } else {
        if (this.discount == null) {
          return this.totalCost;
        }
        if (this.discount > 0 && this.discount <= 100) {
          let costAfterDiscount = this.totalCost * (1 - (this.discount / 100));
          return costAfterDiscount;
        }
        if (this.discount > 100) {
          return 0;
        }
        return this.totalCost;
      }

    },

    changeAmount() {
      let changeAmount = 0;
      if (this.payableAmount == null || this.payableAmount == 0 || this.payableAmount <= this.totalCost) {
        changeAmount = 0;
      } else {
        changeAmount = this.payableAmount - this.totalCost;
      }
      return changeAmount;
    }
  },

  methods: {
    onTableSelect: function (selectedTable) {
      this.failedToChooseTable = false;
      this.errorDuringOrder = false;
      this.errorMessage = "";
      if (this.service.publishesReceipts) {
        if (selectedTable == null) {
          setTimeout(() => {
            try {
              this.willPublishReceiptSelection = false;
              this.hideReceiptOptions = false;
              this.$refs.receiptOrNotComponent.selectPublishReceipt(false);
            } catch (error) {
              console.log("Could not set selection for receipt publish")
            }
          }, 200);
        } else {
          if (selectedTable.defaultCardTerminalId != null && selectedTable.defaultCardTerminalId > 0) {
            let timeoutInMs = this.cardTerminals.length == 0 ? 1000 : 100;

            setTimeout(() => {
              if (this.cardTerminals.length > 1) {
                let cardTerminalOfTableExists = this.cardTerminals.some(cardTerminal => cardTerminal.id == selectedTable.defaultCardTerminalId);
                if (cardTerminalOfTableExists) {
                  this.selectedCardTerminal = selectedTable.defaultCardTerminalId;
                }
              }
            }, timeoutInMs);
          }

          if (selectedTable.wayOfReceiptPublishForPda == 'AUTOMATIC' || selectedTable.wayOfReceiptPublishForPda == 'MANUAL') {
            setTimeout(() => {
              try {
                if ((this.isPaymentsOptionEnabled || selectedTable.showPdaPaymentsOption) && this.table.type != 'DELIVERY' && this.paymentType == 'CARD_TERMINAL' && this.cardTerminals.length > 0 && this.service.publishesReceipts && selectedTable.typeOfReceipt == 'FINAL_RECEIPT' && selectedTable.cardTerminalEnabledForPdaOrders) {
                  this.willPublishReceiptSelection = this.isAbleToPublishReceipts;
                  this.hideReceiptOptions = this.isAbleToPublishReceipts;
                  this.$refs.receiptOrNotComponent.selectPublishReceipt(this.willPublishReceiptSelection);
                } else {
                  this.hideReceiptOptions = false;
                  this.willPublishReceiptSelection = (selectedTable.wayOfReceiptPublishForPda == 'AUTOMATIC' && this.isAbleToPublishReceipts) || this.publishesAlwaysReceipt;
                  this.$refs.receiptOrNotComponent.selectPublishReceipt(this.willPublishReceiptSelection);
                }
              } catch (error) {
                console.log("Could not set selection for receipt publish")
              }
            }, 200);
          }
        }
      }
    },

    toggleIrisPayment() {
      this.irisPayment = !this.irisPayment;
    },

    adjustDiscount() {
      if (this.finalPriceAfterDiscount == null || this.finalPriceAfterDiscount == undefined || this.finalPriceAfterDiscount == "") {
        this.discount = null
      } else if (this.finalPriceAfterDiscount >= this.totalCost) {
        this.discount = null;
      } else {
        let discountMultiplier = this.finalPriceAfterDiscount / this.totalCost;
        let discountMultiplierTo100 = discountMultiplier * 100;
        let discount = 100 - discountMultiplierTo100;
        let discountString = discount.toFixed(2);
        this.discount = Number(discountString);
      }
    },

    adjustFinalPriceAfterDiscount() {
      if (this.discount == null || this.discount == 0) {
        this.finalPriceAfterDiscount = null;
      } else if (this.discount >= 100) {
        this.finalPriceAfterDiscount = 0;
      } else {
        let finalPrice = this.totalCost * (1 - (this.discount / 100));
        let finalPriceString = finalPrice.toFixed(2);
        this.finalPriceAfterDiscount = Number(finalPriceString);

      }
    },

    selectDiscountType(typeOfDiscount) {
      this.typeOfDiscount = typeOfDiscount;
    },

    onCardTerminalSelect() {
      this.failedToChooseCardTerminal = false;
      this.errorDuringOrder = false;
      this.errorMessage = "";
    },

    onPublishReceiptChange(publishReceiptSelection) {
      this.failedToChooseCardTerminal = false;
      this.errorDuringOrder = false;
      this.errorMessage = "";
      this.willPublishReceiptSelection = publishReceiptSelection;
    },

    selectPaymentType(paymentType) {
      this.failedToChooseCardTerminal = false;
      this.errorDuringOrder = false;
      this.errorMessage = "";
      this.paymentType = paymentType;
      this.selectedCardTerminal = null;

      if (this.selectedTable && this.cardTerminals.length > 1 && this.selectedTable.defaultCardTerminalId != null && this.selectedTable.defaultCardTerminalId > 0) {
        let cardTerminalOfTableExists = this.cardTerminals.some(cardTerminal => cardTerminal.id == this.selectedTable.defaultCardTerminalId);
        if (cardTerminalOfTableExists) {
          this.selectedCardTerminal = this.selectedTable.defaultCardTerminalId;
        }
      }

      if ((this.isPaymentsOptionEnabled || (this.selectedTable && this.selectedTable.showPdaPaymentsOption)) && this.table.type != 'DELIVERY' && paymentType == 'CARD_TERMINAL' && this.cardTerminals.length > 0 && this.service.publishesReceipts && this.selectedTable && this.selectedTable.typeOfReceipt == 'FINAL_RECEIPT' && this.selectedTable.cardTerminalEnabledForPdaOrders) {
        try {
          this.willPublishReceiptSelection = this.isAbleToPublishReceipts;
          this.hideReceiptOptions = this.isAbleToPublishReceipts;
          this.$refs.receiptOrNotComponent.selectPublishReceipt(this.willPublishReceiptSelection);
        } catch (error) {
          console.log("Could not set selection for receipt publish")
        } //THE PAYMENT TYPE ON_CREDIT THAT AUTO SWITCHES TO YES RECEIPT IS TEMORARILY ONLY FOR DIRTY-CREPE
      } else if ((this.isPaymentsOptionEnabled || (this.selectedTable && this.selectedTable.showPdaPaymentsOption)) && this.table.type != 'DELIVERY' && (paymentType == 'ON_CREDIT' || paymentType == 'CARD_TERMINAL' || paymentType == 'BANK_ACCOUNT') && this.service.publishesReceipts && this.selectedTable && this.selectedTable.typeOfReceipt == 'FINAL_RECEIPT') {
        this.hideReceiptOptions = false;
        setTimeout(() => {
          try {
            this.willPublishReceiptSelection = this.isAbleToPublishReceipts;
            this.$refs.receiptOrNotComponent.selectPublishReceipt(this.willPublishReceiptSelection);
          } catch (error) {
            console.log("Could not set selection for receipt publish")
          }
        }, 160);
      } else {
        this.hideReceiptOptions = false;
      }
    },

    onTreatChange(willTreatProducts) {
      this.willTreatProducts = willTreatProducts;
    },

    onMembershipOrderChange(isMembershipPdaOrder) {
      this.isMembershipPdaOrder = isMembershipPdaOrder;
    },

    clearPayable() {
      this.payableAmount = null;
    },

    async completeOrder() {
      if (this.cartItems.length == 0) {
        return;
      }

      if (this.table.type == 'DELIVERY') {
        this.$emit("go-to-cart-screen");
      } else if (!this.sendingOrder) {
        this.errorDuringOrder = false;
        this.errorMessage = "";

        let areAllInputsFilledCorrectly = this.areAllInputsFilledCorrectly();

        if (!areAllInputsFilledCorrectly) {
          this.errorDuringOrder = true;
          this.errorMessage = "Συμπληρώστε σωστά όλα τα πεδία που είναι κόκκινα"
          return;
        }

        if ((this.isLoggedIn && !this.isUserVerified && this.service.verifiedOrdersEnabled) || (!this.isLoggedIn && this.service.verifiedOrdersEnabled)) {
          if (this.isLoggedIn) {
            UserApi.logout(this.authToken, this.jwt);
            this.$store.dispatch("setUserData", {});
          }
          this.errorDuringOrder = true;
          this.errorMessage = "Παρακαλώ συνδεθείτε πατώντας το κουμπί 'Είσοδος' που βρίσκεται πάνω αριστερά"
          return;
        }

        this.sendingOrder = true;
        if (!this.isLoggedIn) {
          let crateTempUserResponse = await this.createTemporaryUser();
          if (crateTempUserResponse != 200) {
            this.sendingOrder = false;
            this.errorDuringOrder = true;
            this.errorMessage = "Κάτι πήγε λάθος. Παρακαλώ δοκιμάστε ξανά ή επικοινωνήστε με την τεχνική υποστήριξη";
            return;
          }
        }

        let invoiceDetailsRequest = null;
        if (this.selectedTable && this.selectedTable.typeOfReceipt == 'FINAL_RECEIPT' && (this.selectedTable.wayOfReceiptPublishForPda == 'MANUAL' || this.selectedTable.wayOfReceiptPublishForPda == 'AUTOMATIC') && this.service.publishesReceipts && this.isAbleToPublishReceipts) {
          try {
            let invoiceState = this.$refs.receiptOrNotComponent.getInvoiceState();
            if (invoiceState.isInvoice) {
              let invoiceInfo = invoiceState.invoiceInfo;
              if (invoiceInfo.vat == null || invoiceInfo.vat.trim().length == 0) {
                this.sendingOrder = false;
                let errorMessage = 'Συμπληρώστε το ΑΦΜ. Διαφορετικά ξετσεκάρετε το τιμολόγιο';
                this.$refs.receiptOrNotComponent.setErrorMsg(errorMessage);
                return;
              } else if (invoiceInfo.companyName == null || invoiceInfo.companyName.trim().length == 0) {
                this.sendingOrder = false;
                let errorMessage = 'Συμπληρώστε το όνομα της εταιρείας. Διαφορετικά ξετσεκάρετε το τιμολόγιο';
                this.$refs.receiptOrNotComponent.setErrorMsg(errorMessage);
                return;
              } else if (invoiceInfo.address == null || invoiceInfo.address.trim().length == 0) {
                this.sendingOrder = false;
                let errorMessage = 'Συμπληρώστε την οδό μαζί με αριθμό. Διαφορετικά ξετσεκάρετε το τιμολόγιο';
                this.$refs.receiptOrNotComponent.setErrorMsg(errorMessage);
                return;
              } else if (invoiceInfo.city == null || invoiceInfo.city.trim().length == 0) {
                this.sendingOrder = false;
                let errorMessage = 'Συμπληρώστε την πόλη. Διαφορετικά ξετσεκάρετε το τιμολόγιο';
                this.$refs.receiptOrNotComponent.setErrorMsg(errorMessage);
                return;
              } else if (invoiceInfo.postalCode == null || invoiceInfo.postalCode.trim().length == 0) {
                this.sendingOrder = false;
                let errorMessage = 'Συμπληρώστε τον Τ.Κ. Διαφορετικά ξετσεκάρετε το τιμολόγιο';
                this.$refs.receiptOrNotComponent.setErrorMsg(errorMessage);
                return;
              } else {
                invoiceDetailsRequest = {
                  vat: invoiceInfo.vat,
                  companyName: invoiceInfo.companyName,
                  address: invoiceInfo.address,
                  city: invoiceInfo.city,
                  postalCode: invoiceInfo.postalCode,
                }
              }
            }
          } catch (error) {
            console.log("Could not get invoice state from receipt component")
          }
        }

        let cartItems = this.prepareCartItems();

        let paymentType = this.table.type == 'HOTEL_ROOM' && !(this.isPaymentsOptionEnabled || (this.selectedTable && this.selectedTable.showPdaPaymentsOption)) ? 'ROOM_CHARGE' : this.paymentType;

        let showPaymentMethod = this.table.showPdaPaymentsOption;

        if (this.selectedTable && this.selectedTable.showPdaPaymentsOption) {
          showPaymentMethod = true;
        }

        let adminAccountOfRestaurant = this.adminAccounts.find(account => account.restaurantId == this.service.id);
        if (adminAccountOfRestaurant != null && (!adminAccountOfRestaurant.ableForPartialCashPayment || !adminAccountOfRestaurant.ableForPartialCardPayment)) {
          showPaymentMethod = false;
        }

        let orderData = {
          comment: this.orderComment,
          content: cartItems,
          people: 0,
          chargingRoomId: 0,
          email: null,
          phoneNumber: null,
          mandatoryExtrasOnOrder: null,
          amountOfMandatoryExtras: 0,
          payment: {
            type: paymentType,
            amount: parseInt(this.totalCost * 100),
            showPaymentMethod: showPaymentMethod
          },
        };

        let wayOfReceiptPublish = this.selectedTable.wayOfReceiptPublishForPda;
        if (wayOfReceiptPublish != null && this.service.publishesReceipts) {
          if (wayOfReceiptPublish == 'MANUAL' || wayOfReceiptPublish == 'AUTOMATIC') {

            if ((this.isPaymentsOptionEnabled || (this.selectedTable && this.selectedTable.showPdaPaymentsOption)) && this.table.type != 'DELIVERY' && paymentType == 'CARD_TERMINAL' && this.cardTerminals.length > 0 && this.service.publishesReceipts && this.selectedTable && this.selectedTable.typeOfReceipt == 'FINAL_RECEIPT' && this.selectedTable.cardTerminalEnabledForPdaOrders) {
              try {
                this.willPublishReceiptSelection = this.isAbleToPublishReceipts;
                this.$refs.receiptOrNotComponent.selectPublishReceipt(this.willPublishReceiptSelection);
              } catch (error) {
                console.log("Could not set selection for receipt publish")
              }
            }

            this.sendOrder(orderData, this.willPublishReceiptSelection, invoiceDetailsRequest);
          } else {
            if (this.isAbleToPublishReceipts) {
              this.$confirm({
                message: `Να εκδοθεί και απόδειξη;`,
                button: {
                  yes: 'Ναι',
                  no: 'Όχι'
                },
                callback: async confirm => {
                  if (confirm) {
                    await this.sendOrder(orderData, true, invoiceDetailsRequest);
                  } else {
                    await this.sendOrder(orderData, false, invoiceDetailsRequest);
                  }
                }
              });
            } else {
              await this.sendOrder(orderData, false, invoiceDetailsRequest);
            }

          }
        } else {
          let publishReceiptAfterOrder = this.service.publishesReceipts && this.service.automaticReceiptPublished;
          await this.sendOrder(orderData, publishReceiptAfterOrder, invoiceDetailsRequest);
        }
      }
    },

    adaptStockAmountInMenu(orderProducts) {
      try {
        let storeWithAllServices = this.$store.getters.getStoreWithAllServices;
        if (storeWithAllServices != null && storeWithAllServices != undefined && storeWithAllServices.menus) {
          let restaurantOfOrderInStore = storeWithAllServices.menus.find(menuInStore => menuInStore.restaurant.id == this.service.id);
          if (restaurantOfOrderInStore) {
            orderProducts.forEach(orderProduct => {
              restaurantOfOrderInStore.categories.forEach(category => {
                category.products.forEach(productInCategory => {
                  if (productInCategory.id == orderProduct.product.id) {
                    productInCategory.stockAmount = orderProduct.product.stockAmount;
                  }
                })
              })
            })
          }
        }

        let menuFromRoute = this.$route.params.menu;
        if (menuFromRoute != null && menuFromRoute != undefined && menuFromRoute.menus != null && menuFromRoute.menus != undefined) {
          orderProducts.forEach(orderProduct => {
            menuFromRoute.menus[0].categories.forEach(category => {
              category.products.forEach(productInCategory => {
                if (productInCategory.id == orderProduct.product.id) {
                  productInCategory.stockAmount = orderProduct.product.stockAmount;
                }
              })
            })
          })
        }
      } catch (error) {
        console.log("Could not set stock amount");
        console.log(error);
      }
    },

    async sendOrder(orderData, publishReceiptAfterOrder, invoiceDetailsRequest) {
      if (!this.isAbleToPublishReceipts) {
        publishReceiptAfterOrder = false;
      }

      this.orderOnHold = false;

      let tableOpeningId = this.$route.query && this.$route.query.tableOpeningId != undefined ? this.$route.query.tableOpeningId : null;
      let pdaUserId = this.$route.query && this.$route.query.pdaUserId != undefined ? this.$route.query.pdaUserId : null;

      //id 557 is a hack for golden beach kalamata that wants fast orders
      let orderOnHold = this.service.id != 557 && this.paymentType == 'CARD_TERMINAL' && this.selectedTable.typeOfReceipt == 'FINAL_RECEIPT' && this.cardTerminals.length > 0 && this.table.type != 'DELIVERY' && this.selectedTable.cardTerminalEnabledForPdaOrders && ((publishReceiptAfterOrder && !this.willTreatProducts) || (this.publishesAlwaysReceipt && !this.willTreatProducts)) && ((this.selectedTable.wayOfReceiptPublishForPda == 'MANUAL' || this.selectedTable.wayOfReceiptPublishForPda == 'AUTOMATIC') && this.service.publishesReceipts && this.isAbleToPublishReceipts) && (((this.isPaymentsOptionEnabled && this.table) || (this.table && this.selectedTable && this.selectedTable.showPdaPaymentsOption)) && this.userHasRightsForPaymentMethod);
      orderData.orderOnHold = orderOnHold;

      this.orderOnHold = orderOnHold

      orderData.clientId = this.$route.query && this.$route.query.clientId != undefined ? this.$route.query.clientId : null;

      let result = await OrderApi.postOrder(
        this.selectedTable.id,
        null,
        true,
        this.willTreatProducts,
        this.isMembershipPdaOrder,
        this.service.id,
        orderData,
        this.language,
        this.discount,
        tableOpeningId,
        pdaUserId,
        this.authToken,
        this.jwt
      );

      if (result.status != 200) {
        this.sendingOrder = false;
        this.errorDuringOrder = true;
        this.errorMessage = result.message && result.message.GRE ? result.message.GRE : 'Κάτι πήγε λάθος, δοκιμάστε ξανά';
        return;
      }

      this.adaptStockAmountInMenu(result.products);

      if ((publishReceiptAfterOrder && !this.willTreatProducts) || (this.publishesAlwaysReceipt && !this.willTreatProducts)) {
        let clientId = this.$route.query && this.$route.query.clientId != undefined ? this.$route.query.clientId : null;

        if (result.typeOfReceipt == 'FINAL_RECEIPT') {
          let cardTerminalId = null;
          if ((this.isPaymentsOptionEnabled || (this.selectedTable && this.selectedTable.showPdaPaymentsOption)) && this.table.type != 'DELIVERY' && this.paymentType == 'CARD_TERMINAL' && this.cardTerminals.length > 0 && this.service.publishesReceipts && this.selectedTable.cardTerminalEnabledForPdaOrders) {
            cardTerminalId = this.cardTerminals.length == 1 ? this.cardTerminals[0].id : this.selectedCardTerminal;
          }
          let adminAccountOfRestaurant = this.adminAccounts.find(account => account.restaurantId == this.service.id);
          let userId = adminAccountOfRestaurant != null && adminAccountOfRestaurant != undefined ? adminAccountOfRestaurant.userId : null;
          if (this.orderOnHold) {
            let receiptResponse = await StoreApi.generateFinalReceiptForOrder(result.orderId, this.service.id, cardTerminalId, userId, invoiceDetailsRequest, this.service.paidToExternalServer, this.irisPayment, clientId);
            if (receiptResponse && receiptResponse.error) {
              this.sendingOrder = false;
              this.orderOnHold = false;
              this.errorDuringOrder = true;
              this.errorMessage = "Κάτι πήγε λάθος με την πληρωμή στο POS. Παρακαλώ δοκιμάστε ξανά.";
              return;
            }
          } else {
            StoreApi.generateFinalReceiptForOrder(result.orderId, this.service.id, cardTerminalId, userId, invoiceDetailsRequest, this.service.paidToExternalServer, this.irisPayment, clientId);
          }
        } else {
          let adminAccountOfRestaurant = this.adminAccounts.find(account => account.restaurantId == this.service.id);
          let userId = adminAccountOfRestaurant != null && adminAccountOfRestaurant != undefined ? adminAccountOfRestaurant.userId : null;
          StoreApi.generateTempReceiptForOrder(result.orderId, this.service.id, userId, clientId);
        }
      }

      this.resetState();
      this.$emit("on-successful-order", result.products);

      this.sendingOrder = false;

      this.$confirm({
        message: `Η παραγγελία καταχωρήθηκε επιτυχώς!`,
        button: {
          yes: 'ΟΚ'
        },
        callback: async confirm => {
          if (confirm) {
            if ((this.numberOfServices > 1 || this.redirectBackTo != null) && !this.hideBackToServicesButton && this.service.id != 954 && this.service.id != 979) {
              this.$router.push({
                name: "services",
                params: { tableId: this.redirectBackTo != null ? this.redirectBackTo : this.$router.currentRoute.params.tableId },
              });
            }
          } else {
            if ((this.numberOfServices > 1 || this.redirectBackTo != null) && !this.hideBackToServicesButton && this.service.id != 954 && this.service.id != 979) {
              this.$router.push({
                name: "services",
                params: { tableId: this.redirectBackTo != null ? this.redirectBackTo : this.$router.currentRoute.params.tableId },
              });
            }
          }
        }
      });
    },

    resetState() {
      this.$store.dispatch("emptyCart");
      this.orderComment = "";
      this.payableAmount = null;
      this.willTreatProducts = false;
      this.isMembershipPdaOrder = false;
      this.selectedCardTerminal = null;
      this.irisPayment = false;
      this.orderOnHold = false;
      this.hideReceiptOptions = false;
      this.discount = null;
      this.finalPriceAfterDiscount = null;

      if (this.isPaymentsOptionEnabled) {
        this.paymentType = this.table.type == 'HOTEL_ROOM' ? 'ROOM_CHARGE' : 'CASH';
      }


      if (this.isAbleToTreat) {
        let treatCompoment = this.$refs.chooseTreatComponent;
        if (treatCompoment) {
          try {
            treatCompoment.selectTreat(false);
          } catch (error) {
            console.log("Coult not set treat to false at Treat Component")
          }
        }
      }

      var tableNameElement = this.$refs.tableNameComponent;
      if (tableNameElement) {
        tableNameElement.resetSelected();
      }

      setTimeout(() => {
        try {
          this.$refs.receiptOrNotComponent.resetState();
        } catch (error) {
          console.log("Could not reset state to receipt component")
        }
      }, 200);

      if (this.hideBackToServicesButton && this.selectedTable && this.service.publishesReceipts && this.isAbleToPublishReceipts) {
        setTimeout(() => {
          try {
            let willPublishReceipt = this.selectedTable.wayOfReceiptPublishForPda == 'AUTOMATIC';
            this.$refs.receiptOrNotComponent.selectPublishReceipt(willPublishReceipt);
          } catch (error) {
            console.log("Could not select publish receipt in receipt component")
          }
        }, 300);
      }

      if (this.tableIdsToHideCashAndCardPayment.includes(this.table.id)) {
        this.selectPaymentType("ON_CREDIT");
      }
    },

    areAllInputsFilledCorrectly() {
      let filledCorrectly = true;
      if (!this.selectedTable) {
        this.failedToChooseTable = true;
        filledCorrectly = false;
      }

      if (this.selectedTable && this.selectedTable.typeOfReceipt == 'FINAL_RECEIPT' && this.selectedTable.cardTerminalEnabledForPdaOrders && (this.isPaymentsOptionEnabled || this.selectedTable.showPdaPaymentsOption) && this.table.type != 'DELIVERY' && this.paymentType == 'CARD_TERMINAL' && this.cardTerminals.length > 1 && this.service.publishesReceipts && this.selectedCardTerminal == null) {
        this.failedToChooseCardTerminal = true;
        filledCorrectly = false;
      }

      return filledCorrectly;
    },

    prepareCartItems: function () {
      let cartItems = [];
      if (this.service.membershipEnabled) {
        cartItems = _.map(this.cartItems, (cartItem) =>
          _.pick(cartItem, "comment", "item.id", "item.subselections", "quantity", "kilos", "item.openPrice", "item.price", "item.membershipAddition")
        );
      } else {
        cartItems = _.map(this.cartItems, (cartItem) =>
          _.pick(cartItem, "comment", "item.id", "item.subselections", "quantity", "kilos", "item.openPrice", "item.price")
        );
      }

      cartItems.map((cartItem) => {
        cartItem.productId = cartItem.item.id;

        if (cartItem.item.openPrice) {
          cartItem.price = cartItem.item.price;
        }

        if (cartItem.item.membershipAddition) {
          cartItem.forMember = true;
        }

        let subselectionsToSend = [];
        cartItem.item.subselections.forEach((subselection) => {
          let selectedOptions = subselection.options.filter(
            (option) => option.isSelected
          );
          if (selectedOptions.length > 0) {
            let optionsIds = [];
            selectedOptions.forEach((selectedOption) =>
              optionsIds.push(selectedOption.id)
            );
            subselectionsToSend.push({
              subselectionCategoryId: subselection.id,
              subselectionOptionIds: optionsIds,
            });
          }
        });

        cartItem.subselections = subselectionsToSend;

        delete cartItem.item;

        cartItem.comments = cartItem.comment;
        delete cartItem.comment;
      });

      return cartItems;
    },

    async createTemporaryUser() {
      let response = await UserApi.temporaryLogin(this.storeId);

      if (response.status == 200) {
        this.$store.dispatch("setUserData", response.user);
      }

      return response.status;
    },
  },
  mounted() {
    if (this.table.showPdaPaymentsOption) {
      this.isPaymentsOptionEnabled = true;
    } else if (this.service.tableOpeningsEnabled && (this.table.type == 'TABLE' || this.table.type == 'BEACH_CHAIR' || this.table.type == 'TABLE_AT_HOTEL' || this.table.type == 'UMBRELLA_AT_HOTEL')) {
      this.isPaymentsOptionEnabled = false;
    } else if (this.service.roomOpeningsEnabled && this.table.type == 'HOTEL_ROOM') {
      this.isPaymentsOptionEnabled = false;
    } else {
      this.isPaymentsOptionEnabled = this.table.type == 'DELIVERY' || this.table.type == 'DELIVERY_TABLE' ? this.service.paymentsOptionEnabledForDelivery : this.service.paymentsOptionEnabled;
    }

    if (this.table.type == 'HOTEL_ROOM') {
      this.paymentType = 'ROOM_CHARGE'
    }

    if (this.tableIdsToHideCashAndCardPayment.includes(this.table.id)) {
      this.paymentType = 'ON_CREDIT';
    }
  }
};
</script>

<style scoped>
#pda-cart-summary {
  position: fixed;
  bottom: 8px;
  width: 24vw;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.16), 0 2px 4px rgba(0, 0, 0, 0.23);
  background: white;
  border-radius: 12px;
  clip-path: circle(0% at 100% 0%);
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 98vh;
  overflow-y: scroll;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none;
  z-index: 200;
}

#card-selection-container {
  width: 90%;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  border-bottom: 1px solid rgba(116, 135, 150, 0.2);
  color: black;
  margin-bottom: 0px !important;
  margin-top: 4px !important;
  padding: 4px 0 1px 0 !important;
}

.mt-0 {
  margin-top: 0px !important;
}

.ml-8 {
  margin-left: 8px !important;
}

.iris-logo {
  width: 50px;
}

.iris-option {
  display: flex;
  flex-direction: row;
  cursor: pointer;
  margin-right: 16px;
  margin-top: 2px;
  margin-bottom: 8px;
  align-items: center;
}

.switch {
  margin-left: 8px;
  margin-right: 4px;
  margin-top: 3px;
  position: relative;
  display: inline-block;
  width: 24px;
  height: 14px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  width: 24px !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 10px;
  width: 10px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(10px);
  -ms-transform: translateX(10px);
  transform: translateX(10px);
}

.slider.round {
  border-radius: 14px;
}

.slider.round:before {
  border-radius: 50%;
}

#discount-outer-container {
  display: flex;
  flex-direction: column;
  width: 90%;
  border-bottom: 1px solid rgba(116, 135, 150, 0.2);
  margin-bottom: 4px !important;
}

#discount-input-container {
  width: 90%;
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  color: black;
  margin-bottom: 0px !important;
  padding: 4px 0 1px 0 !important;
}

.zero-margin-top {
  margin-top: 0px !important;
}

.margin-top-4 {
  margin-top: 4px !important;
}

#discount-header {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 5px;
}

#discount-final-price-header {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 0px !important;
}

#discount-input {
  margin-left: 4px;
  background-color: #ffffff;
  font-size: 14px;
  width: 40%;
  padding-left: 5px;
  padding-bottom: 1px;

  border-radius: 5px;
  margin-bottom: 5px;
  box-shadow: 1px 1px 3px rgb(146, 146, 146);
}

#discount-options {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.discount-option {
  display: flex;
  flex-direction: row;
  color: #6d6d6d;
  cursor: pointer;
}

.discount-option-title {
  font-size: 14px;
}

.discount-type-input {
  accent-color: #198b4a;
  margin-bottom: 6px;
  margin-right: 5px;
  height: 22px !important;
}

#card-terminal-label-and-name {
  display: flex;
  flex-direction: column;
}

#card-terminal-label {
  display: flex;
  flex-direction: row;
  align-items: center;
}

#card-terminal-selection-title {
  font-size: 14px;
  font-weight: 600;
}

#pda-cart-summary::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}

#cart-desktop-header {
  padding-top: 6px;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-left: 4%;
  padding-right: 4%;
  padding-bottom: 4px;
  position: sticky;
  top: 0px;
  background-color: #ececec;
  z-index: 206;
  margin-bottom: 10px;
}

#cart-desktop-top-header-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

#to-kalathi-mou {
  margin: 0 0 4px 0;
  color: #003340;
  font-size: 20px;
  font-weight: bold;
}

.total-cost-and-input {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: #ed5005;
}

#total-order-cost {
  font-size: 15px !important;
  font-weight: 700;
  margin-bottom: 0px;
  white-space: nowrap !important;
}

#return-change-amount {
  font-size: 14px !important;
  font-weight: 600;
  color: #003340;
  margin-top: 0px;
  margin-bottom: 0px;
}

.amount-received-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 6px;
  box-shadow: inset 1px 1px 1px 0 rgba(0, 0, 0, 0.2);
  padding-left: 1px;
  background: #0d6efd17;
  width: 40%;
  height: 30px !important;
  margin-left: 0px;
}

.amount-received-input {
  padding: 2px 3px 2px 6px;
  width: 93%;
  font-size: 14px;
  border-radius: 6px;
  height: 35px !important;
  font-weight: 500 !important;
}

.cost-before-discount {
  color: #686868 !important;
  font-weight: 500;
  font-style: italic;
  text-decoration: line-through;
}

.clear-amount-input {
  margin-right: 4px;
  color: #575757 !important;
  cursor: pointer;
}

#choose-payment-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 4px;
  padding-bottom: 4px;
}

.payment-option {
  background-color: #ffffff;
  flex: 1;
  display: flex;
  font-weight: 500;
  font-size: 15px;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  height: 35px;
  cursor: pointer;
}

.selected-payment-type {
  background-color: #0275d8 !important;
  color: white !important;
  font-weight: 700;
}

.pt-4 {
  padding-top: 4px !important;
}

.mt-18 {
  margin-top: 20px !important;
}

#send-order {
  position: sticky;
  position: -webkit-sticky;
  background-color: #eaeaea !important;
  z-index: 400;
  bottom: 0;
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 10px rgb(213 213 213);
}

#comment-text-area {
  font-size: 15px;
  background-color: white;
  width: 90%;
  border-radius: 10px;
  margin-bottom: 8px;
  resize: none;
  padding-left: 4px;
  padding-right: 2px;
  padding-bottom: 2px;
  height: 42px;
  margin-top: 2px;
}

#send-order-button {
  width: 90%;
  min-height: 45px !important;
  max-height: 45px !important;
  border: none;
  margin-bottom: 10px;
  background: linear-gradient(62deg, #198b4a, #04d36f);
  color: white;
  font-size: 12px;
  font-weight: 600;
}

#order-on-hold-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

#order-on-hold-message {
  display: flex;
  flex-direction: row;
  color: #003340;
  padding-right: 3px;
  padding-left: 3px;
  text-align: center;
  margin-bottom: 0px;
  font-weight: 600;
}

#waiting-gif {
  height: 88px;
  margin-bottom: 0px;
}

#error-message {
  color: red;
  padding-right: 3px;
  padding-left: 3px;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
}

#unavailable-store-msg {
  color: #003340;
  padding-right: 3px;
  padding-left: 3px;
  text-align: center;
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 0px;
}

#store-schedule {
  color: #003340;
  padding-right: 3px;
  padding-left: 3px;
  text-align: center;
  font-weight: 700;
  font-size: 17px;
}

.grayOut {
  opacity: 0.65;
}

.highlight {
  border-radius: 10px;
  background: rgba(255, 50, 50, 0.35);
  margin-top: 10px;
  padding-left: 10px !important;
  padding-top: 1rem !important;
}

select {
  display: flex;
  align-self: center;
  justify-self: center;
  -webkit-appearance: auto !important;
  box-shadow: inset 0px 0px 2px rgba(116, 135, 150, 0.2),
    inset 1px 1px 2px rgba(116, 135, 150, 0.36);
  border-radius: 6px;
  margin-bottom: 0.5rem;
  margin-left: 7px;
  padding: 2px;
  color: #198b4a !important;
  font-weight: bold;
  background: #f7f7f7;
}

.prevent-select {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

@media screen and (max-width: 1397px) {
  #total-order-cost {
    font-size: 14px !important;
    font-weight: 600;
  }

  #return-change-amount {
    font-size: 12px !important;
    font-weight: 600;
  }

  #card-terminal-selection-title {
    font-size: 12px;
    font-weight: 500;
  }

  #card-terminal-select-dropdown {
    font-size: 12px;
    font-weight: 500;
  }

  .payment-option {
    height: 28px;
    font-weight: 500;
    font-size: 13px;
  }

  #comment-text-area {
    font-size: 12px;
    height: 31px;
  }

  #discount-header {
    font-size: 12px;
    font-weight: 600;
  }

  #discount-final-price-header {
    font-size: 12px;
    font-weight: 600;
  }

  #discount-input {
    font-size: 12px;
  }

  #send-order-button {
    min-height: 35px !important;
    max-height: 35px !important;
  }

  .amount-received-input {
    font-size: 12px;
    height: 30px !important;
    font-weight: 500 !important;
  }
}
</style>



